import CharacterCounter from './components/CharacterCounter'

import './App.css'

// Replace your code here
const App = () => (
  <div>
    <CharacterCounter />
  </div>
)

export default App
